/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkImportReserveForm } from '../models/BulkImportReserveForm';
import type { BulkImportReserveResponse } from '../models/BulkImportReserveResponse';
import type { FileDownloadUrlResponse } from '../models/FileDownloadUrlResponse';
import type { GenerateFileUploadItemsResponse } from '../models/GenerateFileUploadItemsResponse';
import type { PageBulkImportIndexResponse } from '../models/PageBulkImportIndexResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BulkImportRepository {

  /**
   * 一括登録履歴一覧表示
   * @returns PageBulkImportIndexResponse OK
   * @throws ApiError
   */
  public static index({
    categories,
    uploadedStartDateTime,
    uploadedEndDateTime,
    statuses,
    page = 1,
    size = 20,
    sort,
  }: {
    /**
     * カテゴリ（複数指定可能）
     */
    categories: Array<'ACCOUNT' | 'COMPANY' | 'SHOP' | 'TERMINAL' | 'SMART_CODE_SHOP' | 'SMART_CODE_COMPANY' | 'SHOP_WALLET_SETTING' | 'SHOP_SPLIT_PAYMENT'> | undefined,
    /**
     * アップロード日時(開始日)
     */
    uploadedStartDateTime: string | undefined,
    /**
     * アップロード日時(終了日)
     */
    uploadedEndDateTime: string | undefined,
    /**
     * ステータス（複数指定可能）
     */
    statuses: Array<'RESERVED' | 'PROCESSING' | 'COMPLETED' | 'FAILED'> | undefined,
    /**
     * One-based page index (1..N)
     */
    page: number | undefined,
    /**
     * The size of the page to be returned
     */
    size: number | undefined,
    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    sort: Array<string> | undefined,
  }): CancelablePromise<PageBulkImportIndexResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/bulk_import',
      query: {
        'categories': categories,
        'uploadedStartDateTime': uploadedStartDateTime,
        'uploadedEndDateTime': uploadedEndDateTime,
        'statuses': statuses,
        'page': page,
        'size': size,
        'sort': sort,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 一括登録予約
   * @returns BulkImportReserveResponse OK
   * @throws ApiError
   */
  public static reserve({
    requestBody,
  }: {
    /**
     * 一括登録予約基本情報
     */
    requestBody: BulkImportReserveForm,
  }): CancelablePromise<BulkImportReserveResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/bulk_import',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * ファイル名＆署名付きURL生成
   * @returns GenerateFileUploadItemsResponse OK
   * @throws ApiError
   */
  public static generate(): CancelablePromise<GenerateFileUploadItemsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/bulk_import/generate',
      errors: {
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 一括登録エラーCsvをダウンロードするための署名付きURLを返却する
   * @returns FileDownloadUrlResponse OK
   * @throws ApiError
   */
  public static downloadError({
    id,
  }: {
    /**
     * 一括登録ID
     */
    id: string,
  }): CancelablePromise<FileDownloadUrlResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/bulk_import/{id}/download/error',
      path: {
        'id': id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * 一括登録予約CSVダウンロード
   * @returns FileDownloadUrlResponse OK
   * @throws ApiError
   */
  public static downloadOriginal({
    id,
  }: {
    /**
     * 一括登録ID
     */
    id: string,
  }): CancelablePromise<FileDownloadUrlResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/bulk_import/{id}/download/original',
      path: {
        'id': id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        500: `Internal Server Error`,
      },
    });
  }

}
